// Окно «Новая команда»: название команды перед вступлением в соревнование (useCreateTeam).
// На компьютере окно поверх страницы, на телефоне лист снизу.
import { Alert, BottomSheet, Field } from "@/ui";
import { GenerateName } from "@/ui/GenerateName";
import { useIsMobile } from "@/ui/media";
import "@/ui/myteam.css";

export function TeamNameDialog({
  competitionId,
  competitionName,
  value,
  onChange,
  error,
  pending,
  onCancel,
  onConfirm,
}: {
  competitionId: string;
  competitionName?: string;
  value: string;
  onChange: (v: string) => void;
  error: string | null;
  pending: boolean;
  onCancel: () => void;
  onConfirm: () => void;
}) {
  const mobile = useIsMobile();
  const ok = value.trim().length >= 2;
  const body = (
    <form
      className="team-name-form"
      onKeyDown={(e) => e.key === "Escape" && onCancel()}
      onSubmit={(e) => {
        e.preventDefault();
        onConfirm();
      }}
    >
      {competitionName && <span className="small muted">Соревнование «{competitionName}»</span>}
      <Field
        label="Название команды"
        id="new-team-name"
        value={value}
        maxLength={64}
        autoFocus
        placeholder="Например, Ледяные волки"
        hint="От 2 до 64 символов, его видят все участники"
        onChange={(e) => onChange(e.target.value)}
        action={<GenerateName target={{ kind: "team", competitionId }} onPick={onChange} />}
      />
      {error && <Alert kind="error">{error}</Alert>}
      <div className="mt-dialog__actions">
        <button type="button" className="btn btn--secondary" onClick={onCancel}>
          Отмена
        </button>
        <button type="submit" className="btn" disabled={!ok || pending}>
          {pending ? "Создаём…" : "Создать команду"}
        </button>
      </div>
    </form>
  );
  if (mobile)
    return (
      <BottomSheet open title="Новая команда" onClose={onCancel}>
        {body}
      </BottomSheet>
    );
  return (
    <div className="mt-overlay" onMouseDown={(e) => e.target === e.currentTarget && onCancel()}>
      <div className="mt-dialog" role="dialog" aria-modal="true" aria-labelledby="team-name-title">
        <h2 id="team-name-title">Новая команда</h2>
        {body}
      </div>
    </div>
  );
}
